"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getRequestPayload = function getRequestPayload(action) {
  return {
    data: {
      type: 'cart',
      id: action.cartID,
      attributes: {
        product_id: action.productID,
        quantity: action.quantity
      }
    }
  };
};

var _default = getRequestPayload;
exports.default = _default;